import React from 'react';
import Linkify from 'react-linkify';
import styled from 'styled-components';
import Link from '@tools/ui/components/common/links/Link';
import { theme } from '../../theme/semanticTokens';
import { sanitizeRichTextHtml } from './richTextSanitize';

export interface RichTextDisplayProps {
  content: string;
  className?: string;
}

const HTML_TAG_REGEX = /^<(p|ul|ol)[\s>]/i;

const DisplayWrapper = styled.div`
  font-family: ${theme.dime.fonts.families.roboto};
  font-size: 14px;
  line-height: 1.5;
  color: ${theme.dime.colors.text.primary};
  white-space: pre-wrap;
  word-wrap: break-word;

  p {
    margin: 0 0 4px 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  s {
    text-decoration: line-through;
  }

  ul,
  ol {
    margin: 0 0 8px 0;
    padding-left: 24px;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    margin: 0 0 4px 0;
  }
`;

export const RichTextDisplay: React.FC<RichTextDisplayProps> = ({
  content,
  className
}) => {
  if (!HTML_TAG_REGEX.test(content)) {
    return (
      <DisplayWrapper className={className}>
        <Linkify
          componentDecorator={(decoratedHref, decoratedText, key) => (
            <Link target="blank" key={key} href={decoratedHref}>
              {decoratedText}
            </Link>
          )}
        >
          {content}
        </Linkify>
      </DisplayWrapper>
    );
  }

  const sanitizedContent = sanitizeRichTextHtml(content);

  return (
    <DisplayWrapper
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};
